// extracted by mini-css-extract-plugin
export default {"container":"PageContent_container__qMykj","defaultIndent":"PageContent_defaultIndent__+nT73"};